export enum OpenType {
    SAME_TAB = "SAME_TAB",
    NEW_TAB_NO_SWITCH = "NEW_TAB_NO_SWITCH",
    NEW_TAB_WITH_SWITCH = "NEW_TAB_WITH_SWITCH",
    NEW_WINDOW = "NEW_WINDOW"
}
